import App from "../App";
import HomeLayout from "../layouts/home/home";
import CategoryLayout from "../layouts/category/category";
import ArticleLayout from "../layouts/article/article";
import ArticleTypeLayout from "../layouts/articleType/articleType";
import AuthorLayout from "../layouts/author/author";
import AboutLayout from "../layouts/about/about";
import TagResultsLayout from "../layouts/tagResultsTemplate/tagResultsTemplate";
import SearchResultsTemplate from "../layouts/searchResultsTemplate/searchResultsTemplate";
import PageLayout from "../layouts/page/page";

import {
  CATEGORIES,
  SPECIAL_CATEGORIES,
  HOME_ROUTE_PATTERN,
  ARTICLE_ROUTE_PATTERN,
  ABOUT_ROUTE_PATTERN,
  AUTHOR_ROUTE_PATTERN,
  TAG_RESULTS_ROUTE_PATTERN,
  SEARCH_RESULTS_ROUTE_PATTERN,
  NOT_FOUND_ROUTE_PATTERN,
} from "./constants";

const categoriesRoutes = CATEGORIES.map(category => ({
  path: category,
  Component: ArticleTypeLayout,
}));

const specialCategoriesRoutes = SPECIAL_CATEGORIES.map(specialCategory => ({
  path: specialCategory,
  Component: CategoryLayout,
}));

const routes = [
  {
    Component: App,
    children: [
      {
        path: HOME_ROUTE_PATTERN,
        Component: HomeLayout,
      },
      {
        path: ARTICLE_ROUTE_PATTERN,
        Component: ArticleLayout,
      },
      {
        path: ABOUT_ROUTE_PATTERN,
        Component: AboutLayout,
      },
      {
        path: AUTHOR_ROUTE_PATTERN,
        Component: AuthorLayout,
      },
      {
        path: TAG_RESULTS_ROUTE_PATTERN,
        Component: TagResultsLayout,
      },
      {
        path: SEARCH_RESULTS_ROUTE_PATTERN,
        Component: SearchResultsTemplate,
      },
      ...categoriesRoutes,
      ...specialCategoriesRoutes,
      {
        path: NOT_FOUND_ROUTE_PATTERN,
        Component: PageLayout,
      },
    ],
  },
];

export default routes;
